const example = {
	attributes: {
		isPreview: true,
		carouselOptions: {
			type: 'slide',
			arrows: true,
			pagination: true,
		},
	},
	innerBlocks: [
		{
			name: 'groundworx/slide',
			attributes: {},
			innerBlocks: [
				{
					name: 'core/paragraph',
					attributes: {
						content: 'This is a sample slide.',
					},
				},
			],
		},
        {
			name: 'groundworx/slide',
			attributes: {},
			innerBlocks: [
				{
					name: 'core/paragraph',
					attributes: {
						content: 'This is a sample slide.',
					},
				},
			],
		},
        {
			name: 'groundworx/slide',
			attributes: {},
			innerBlocks: [
				{
					name: 'core/paragraph',
					attributes: {
						content: 'This is a sample slide.',
					},
				},
			],
		},
	],
};

export default example;